import './FaqCard.scss';

import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai';
import { ENTER_KEY_CODE } from '../../utils/constants';

interface Props {
  id: number;
  question: string;
  anwser: string;
  isOpen: boolean;
  toggleOpen: (id: number) => void;
}

const FaqCard = (props: Props) => {
  return (
    <div
      className="faq-body"
      onClick={() => props.toggleOpen(props.id)}
      tabIndex={0}
      onKeyDown={(e: any) => {
        if (e.keyCode == ENTER_KEY_CODE) e.target.click();
      }}
    >
      <div className="spacing">
        <h3 className="faq-question-title">{props.question}</h3>
        <div>
          {props.isOpen ? (
            <AiFillCaretUp size={21} />
          ) : (
            <AiFillCaretDown size={21} />
          )}
        </div>
      </div>
      {props.isOpen && (
        <p
          className="faq-body-response"
          dangerouslySetInnerHTML={{ __html: props.anwser }}
        />
      )}
    </div>
  );
};

export default FaqCard;
